module.exports = __webpack_public_path__ + "static/media/md-heart-empty.8b8cfd84.svg";